import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, AlertCircle, HeartCrack } from 'lucide-react';
export function ProblemAgitation() {
  const painPoints = [{
    icon: AlertCircle,
    title: 'Información contradictoria',
    text: 'Internet está lleno de consejos opuestos que solo generan más confusión y ansiedad.'
  }, {
    icon: HeartCrack,
    title: 'Desgaste emocional',
    text: 'Probar métodos que no funcionan desgasta la relación con tus hijos y tu propia paciencia.'
  }, {
    icon: XCircle,
    title: 'Culpa constante',
    text: 'Sentir que deberías saber cómo manejarlo todo, pero la realidad te supera día a día.'
  }];
  return <section className="py-24 px-4 bg-[#FBF8F4]" data-id="element-188">
      <div className="max-w-6xl mx-auto" data-id="element-189">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-190">
          <h2 className="font-serif text-3xl md:text-4xl text-[#3D3229] mb-6" data-id="element-191">
            La falta de una guía clara tiene un costo alto
          </h2>
          <p className="text-lg text-[#5C4A3A] max-w-2xl mx-auto" data-id="element-192">
            Criar desde la intuición es maravilloso, pero cuando los desafíos
            nos superan, necesitamos herramientas concretas. Sin ellas, el hogar
            se convierte en un campo de batalla.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-193">
          {painPoints.map((point, index) => <motion.div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-[#EBE5DB]" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-194">
              <div className="w-12 h-12 bg-[#F5F0E8] rounded-full flex items-center justify-center mb-6 text-[#8B4513]" data-id="element-195">
                <point.icon size={24} data-id="element-196" />
              </div>
              <h3 className="font-serif text-xl text-[#3D3229] mb-3 font-semibold" data-id="element-197">
                {point.title}
              </h3>
              <p className="text-[#5C4A3A] leading-relaxed" data-id="element-198">{point.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}